import { render, staticRenderFns } from "./TableSettingsDialog.vue?vue&type=template&id=20441d6c&"
import script from "./TableSettingsDialog.vue?vue&type=script&lang=js&"
export * from "./TableSettingsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports